import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/tmp/build_625ec67b/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_625ec67b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BugReportBlock"] */ "/tmp/build_625ec67b/src/payload/blocks/BugReport/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactFormBlock"] */ "/tmp/build_625ec67b/src/payload/blocks/ContactForm/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TutorialsBlock"] */ "/tmp/build_625ec67b/src/payload/blocks/Tutorials/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/tmp/build_625ec67b/src/ui/shadcn/accordion.tsx");
